import { h } from "preact";
import { RoutableProps } from "preact-router";
import { applicationState } from "../../App";
import "../../../views/styles.scss";

export function Home(props: RoutableProps) {
    const state = applicationState;

    return <div>

    </div>;
}